import { CSSProperties, ReactNode } from "react"
import { ButtonProps } from "shared-web/components/base/control/Button"
import { IconButtonProps } from "shared-web/components/base/control/IconButton"
import { PopoverComboboxItem } from "shared-web/components/composite/popover"
import { IconProps } from "shared-web/components/Icon"

export const PopoverMenuButtonVariants = {
  Text: "text",
  Icon: "icon",
  Default: "default",
} as const
export type PopoverMenuButtonVariant =
  (typeof PopoverMenuButtonVariants)[keyof typeof PopoverMenuButtonVariants]

export interface DefaultPopoverMenuButtonProps {
  buttonVariant?: typeof PopoverMenuButtonVariants.Default
  buttonMode?: ButtonProps["mode"]
  buttonSize?: ButtonProps["size"]
  buttonLeftIcon?: ButtonProps["leftIcon"]
  buttonTitle: string
}

export interface IconPopoverMenuButtonProps {
  buttonVariant: typeof PopoverMenuButtonVariants.Icon
  buttonMode?: IconButtonProps["mode"]
  buttonSize?: IconButtonProps["size"]
  icon: IconProps["icon"]
}

export interface TextPopoverMenuButtonProps {
  buttonVariant: typeof PopoverMenuButtonVariants.Text
  buttonTitle: string
}

export type PopoverMenuButtonProps =
  | DefaultPopoverMenuButtonProps
  | IconPopoverMenuButtonProps
  | TextPopoverMenuButtonProps

interface BasePopoverMenuProps {
  items: PopoverComboboxItem[]
  onSelect: (item: PopoverComboboxItem) => void
  onChangeQuery: (query: string) => void
  className?: string
  style?: CSSProperties
}

export type PopoverMenuProps = BasePopoverMenuProps &
  (
    | DefaultPopoverMenuButtonProps
    | IconPopoverMenuButtonProps
    | TextPopoverMenuButtonProps
  )

export type PopoverMenuComboboxProps = Pick<
  PopoverMenuProps,
  "items" | "onSelect" | "onChangeQuery"
>

export interface UsePopoverMenuProps<T>
  extends Pick<PopoverMenuProps, "onChangeQuery"> {
  items: T[]
  onSelect: (item: T) => void
  keyExtractor: (item: T) => string
  labelExtractor: (item: T) => string
  contentExtractor?: (item: T) => ReactNode
  footerItem?: PopoverComboboxItem
  onSelectFooter?: () => void
}

export interface UsePopoverMenuRes {
  popoverMenuProps: Pick<
    PopoverMenuProps,
    "items" | "onSelect" | "onChangeQuery"
  >
}
